export default __webpack_public_path__ + "static/media/fpa50030.5ec5b5a8.png";